var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Numero","placeholder":"Numero","hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.numero),callback:function ($$v) {_vm.numero=$$v},expression:"numero"}})}
var staticRenderFns = []

export { render, staticRenderFns }